export default __webpack_public_path__ + "static/phone-88c7b6c5dd2065ac3fbbe8615b956e64.png";